import { bindKeymapWithCommand, enter } from '@atlaskit/editor-common/keymaps';
import type { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { NextEditorPlugin } from '@atlaskit/editor-common/types/next-editor-plugin';
import { insertNewLine } from '@atlaskit/editor-common/utils/commands';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';

export const promptHardBreakKeymapPlugin: NextEditorPlugin<'promptHardBreakKeymap'> = () => ({
	name: 'promptHardBreakKeymap',
	pmPlugins() {
		const keymaps = {};

		bindKeymapWithCommand(enter.common ?? 'Enter', insertNewLine(), keymaps);

		return [
			{
				name: 'promptHardBreakKeymap',
				plugin: () => keymap(keymaps) as SafePlugin,
			},
		];
	},
});
